import React, {memo} from "../../__snowpack__/pkg/react.js";
import {useIntl} from "../../__snowpack__/pkg/react-intl.js";
import {Tooltip} from "../../__snowpack__/pkg/antd.js";
const ICON_MAP = {
  cod: {
    url: "/images/icon-action/cod.svg",
    title: "cod"
  },
  brush_order: {
    url: "/images/icon-action/brush_order.svg",
    title: "fakeOrder"
  },
  pre_sale: {
    url: "/images/icon-action/pre_sale.svg",
    title: "preorder11"
  },
  distribution: {
    url: "/images/icon-action/distribution.svg",
    title: "dropshipper"
  },
  giveaway: {
    url: "/images/icon-action/giveaway.svg",
    title: "gift"
  },
  printed_express: {
    url: "/images/icon-action/printed_express.svg",
    title: "LabelAlreadyPrinted"
  },
  packed: {
    url: "/images/icon-action/packed.svg",
    title: "AlreadyPacked"
  },
  printed_bill: {
    url: "/images/icon-action/printed_bill.svg",
    title: "InvoiceAlreadyPrinted"
  },
  printed_picklist: {
    url: "/images/icon-action/printed_picklist.svg",
    title: "PickingListAlreadyPrinted"
  },
  pack_print: {
    url: "/images/icon-action/pack_print.svg",
    title: "PackingListAlreadyPrinted"
  },
  all_pick: {
    url: "/images/icon-action/all_pick.svg",
    title: "Picked"
  },
  customize: {
    url: "/images/icon-action/customize.svg",
    title: ""
  },
  unpicked: {
    url: "/images/icon-action/unpicked.svg",
    title: ""
  },
  blacklist: {
    url: "/images/icon-action/blacklist.svg",
    title: "blacklist"
  },
  message: {
    url: "/images/icon-action/message.svg",
    title: "buyerNote"
  },
  change_warehouse_success: {
    url: "/images/icon-action/change_warehouse_success.svg",
    title: "warehouseChangeSucceeded"
  },
  change_warehouse_fail: {
    url: "/images/icon-action/change_warehouse_fail.svg",
    title: "warehouseChangeFailed"
  },
  change_warehouse: {
    url: "/images/icon-action/change_warehouse.svg",
    title: "warehouseChange"
  },
  split_order: {
    url: "/images/icon-action/split_order.svg",
    title: "splitOrder"
  },
  split_package: {
    url: "/images/icon-action/split_package.svg",
    title: "packageSplit"
  },
  bopis: {
    url: "/images/icon-action/bopis.svg",
    title: "bopis"
  },
  big_product: {
    url: "/images/icon-action/big_product.svg",
    title: "bigProduct"
  },
  create_receipt: {
    url: "/images/icon-action/create_receipt.svg",
    title: "inboundReturnProduct"
  },
  fulfilled_lazada: {
    url: "/images/icon-action/fulfilled_lazada.svg",
    title: "Fulfilled By Lazada"
  },
  fulfilled_shopee: {
    url: "/images/icon-action/fulfilled_shopee.svg",
    title: "Fulfilled By Shopee"
  },
  fulfilled_tokocabang: {
    url: "/images/icon-action/fulfilled_tokocabang.svg",
    title: "TOKOCABANG"
  },
  scaned: {
    url: "/images/icon-action/scan_status.svg",
    title: "scanned"
  },
  offline: {
    url: "/images/icon-action/offline.svg",
    title: "offlineOrder"
  },
  file: {
    url: "/images/icon-action/file.svg",
    title: "withAttachments"
  },
  priority_delivery: {
    url: "/images/icon-action/priority_delivery.svg",
    title: "Priority Delivery"
  },
  channel_order_status: {
    url: "/images/icon-action/channel_order_status.svg",
    title: "hasReturnrefund"
  },
  shopee_pending: {
    url: "/images/icon-action/shopee_pending.svg",
    title: "tipShopeePendingWaitingForShopee"
  },
  o2o: {
    url: "/images/icon-action/o2o.svg",
    title: "ooOrders"
  }
};
const ActionIcon = memo((props) => {
  const {formatMessage} = useIntl();
  const {type = "default", ...imgProps} = props;
  const icon = ICON_MAP[type];
  const titleId = props?.title ? props.title : icon?.title;
  return /* @__PURE__ */ React.createElement(Tooltip, {
    title: /* @__PURE__ */ React.createElement("div", {
      style: {color: "#202D40", maxWidth: "300px"}
    }, formatMessage({id: titleId})),
    autoAdjustOverflow: true,
    color: "white"
  }, /* @__PURE__ */ React.createElement("img", {
    onClick: props?.onCallBack,
    src: icon.url,
    style: {
      display: "inline-block",
      width: 16,
      height: 16,
      ...imgProps.style
    },
    ...imgProps
  }));
});
export default ActionIcon;
